import APP_ROUTES from '~/src/Constants/APP_ROUTES'

export default function NotFoundLoader() {
  throw new Response(APP_ROUTES.LANDING.pathname as string, {
    status: 404
  })

  return {}
}
